export default __webpack_public_path__ + "static/project2-2dab089fe83850250c924e6f4fd0e35f.jpg";